'use client';

import { AwsRum, type AwsRumConfig } from 'aws-rum-web';

declare global {
  interface Window { __rumInit?: boolean; __awsRum?: AwsRum }
}

export function initRum() {
  if (typeof window === 'undefined' || window.__rumInit) return;

  // Validate required environment variables
  const requiredEnvVars = {
    NEXT_PUBLIC_AWS_RUM_APP_ID: process.env.NEXT_PUBLIC_AWS_RUM_APP_ID,
    NEXT_PUBLIC_AWS_RUM_REGION: process.env.NEXT_PUBLIC_AWS_RUM_REGION,
    NEXT_PUBLIC_AWS_RUM_IDENTITY_POOL_ID: process.env.NEXT_PUBLIC_AWS_RUM_IDENTITY_POOL_ID,
    NEXT_PUBLIC_AWS_RUM_SAMPLE_RATE: process.env.NEXT_PUBLIC_AWS_RUM_SAMPLE_RATE,
    NEXT_PUBLIC_APP_VERSION: process.env.NEXT_PUBLIC_APP_VERSION,
  };

  const missingVars = Object.entries(requiredEnvVars)
    .filter(([, value]) => !value)
    .map(([key]) => key);

  if (missingVars.length > 0) {
    console.warn(`[RUM] Missing required environment variables: ${missingVars.join(', ')}`);
  }

  try {
    const config: AwsRumConfig = {
      sessionSampleRate: Number(process.env.NEXT_PUBLIC_AWS_RUM_SAMPLE_RATE ?? 1),
      identityPoolId: process.env.NEXT_PUBLIC_AWS_RUM_IDENTITY_POOL_ID!,
      endpoint: `https://dataplane.rum.${process.env.NEXT_PUBLIC_AWS_RUM_REGION}.amazonaws.com`,
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
    };

    window.__awsRum = new AwsRum(
      process.env.NEXT_PUBLIC_AWS_RUM_APP_ID!,     // from CDK output RumAppMonitorId
      process.env.NEXT_PUBLIC_APP_VERSION ?? '1.0.0',
      process.env.NEXT_PUBLIC_AWS_RUM_REGION!,     // e.g. us-east-1
      config
    );

    // Optional: add session/page attributes (filter in the console)
    // window.__awsRum.addSessionAttributes({ env: process.env.NEXT_PUBLIC_ENV });
    // window.__awsRum.recordPageView({ pageId: window.location.pathname });

    window.__rumInit = true;
  } catch {
    // ignore init errors
  }
}
